// src/components/bio/LocalitySelector.js
import React from 'react';

// Hardcoded options for simplicity, ensure this list matches localityAdjustments keys
const localityOptions = [
  { value: "DC", label: "Washington‑Baltimore‑Arlington, DC‑MD‑VA‑WV‑PA" },
  { value: "ALBANY", label: "Albany‑Schenectady, NY‑MA" },
  { value: "ALBUQUERQUE", label: "Albuquerque‑Santa Fe‑Las Vegas, NM" },
  { value: "ATLANTA", label: "Atlanta–Athens–Clarke County–Sandy Springs, GA‑AL" },
  { value: "AUSTIN", label: "Austin‑Round Rock‑Georgetown, TX" },
  { value: "BIRMINGHAM", label: "Birmingham‑Hoover‑Talladega, AL" },
  { value: "BOSTON", label: "Boston‑Worcester‑Providence, MA‑RI‑NH‑CT‑ME‑VT" },
  { value: "BUFFALO", label: "Buffalo‑Cheektowaga‑Olean, NY" },
  { value: "BURLINGTON", label: "Burlington‑South Burlington‑Barre, VT" },
  { value: "CHARLOTTE", label: "Charlotte‑Concord, NC‑SC" },
  { value: "CHICAGO", label: "Chicago‑Naperville, IL‑IN‑WI" },
  { value: "CINCINNATI", label: "Cincinnati‑Wilmington‑Maysville, OH‑KY‑IN" },
  { value: "CLEVELAND", label: "Cleveland‑Akron‑Canton, OH‑PA" },
  { value: "COLORADO_SPRINGS", label: "Colorado Springs, CO" },
  { value: "COLUMBUS", label: "Columbus‑Marion‑Zanesville, OH" },
  { value: "CORPUS_CHRISTI", label: "Corpus Christi‑Kingsville‑Alice, TX" },
  { value: "DALLAS", label: "Dallas‑Fort Worth, TX‑OK" },
  { value: "DAVENPORT", label: "Davenport‑Moline, IA‑IL" },
  { value: "DAYTON", label: "Dayton‑Springfield‑Kettering, OH" },
  { value: "DENVER", label: "Denver‑Aurora, CO" },
  { value: "DES_MOINES", label: "Des Moines‑Ames‑West Des Moines, IA" },
  { value: "DETROIT", label: "Detroit‑Warren‑Ann Arbor, MI" },
  { value: "FRESNO", label: "Fresno‑Madera‑Hanford, CA" },
  { value: "HARRISBURG", label: "Harrisburg‑Lebanon, PA" },
  { value: "HARTFORD", label: "Hartford‑East Hartford, CT‑MA" },
  { value: "HOUSTON", label: "Houston‑The Woodlands, TX" },
  { value: "HUNTSVILLE", label: "Huntsville‑Decatur, AL‑TN" },
  { value: "INDIANAPOLIS", label: "Indianapolis‑Carmel‑Muncie, IN" },
  { value: "KANSAS_CITY", label: "Kansas City‑Overland Park‑Kansas City, MO‑KS" },
  { value: "LAREDO", label: "Laredo, TX" },
  { value: "LAS_VEGAS", label: "Las Vegas‑Henderson, NV‑AZ" },
  { value: "LA", label: "Los Angeles‑Long Beach, CA" },
  { value: "MIAMI", label: "Miami‑Port St. Lucie‑Fort Lauderdale, FL" },
  { value: "MILWAUKEE", label: "Milwaukee‑Racine‑Waukesha, WI" },
  { value: "MINNEAPOLIS", label: "Minneapolis‑St. Paul, MN‑WI" },
  { value: "NY", label: "New York‑Newark, NY‑NJ‑CT‑PA" },
  { value: "OMAHA", label: "Omaha‑Council Bluffs‑Fremont, NE‑IA" },
  { value: "PALM_BAY", label: "Palm Bay‑Melbourne‑Titusville, FL" },
  { value: "PHILADELPHIA", label: "Philadelphia‑Reading‑Camden, PA‑NJ‑DE‑MD" },
  { value: "PHOENIX", label: "Phoenix‑Mesa, AZ" },
  { value: "PITTSBURGH", label: "Pittsburgh‑New Castle‑Weirton, PA‑OH‑WV" },
  { value: "PORTLAND", label: "Portland‑Vancouver‑Salem, OR‑WA" },
  { value: "RALEIGH", label: "Raleigh‑Durham‑Cary, NC" },
  { value: "RENO", label: "Reno‑Fernley, NV" },
  { value: "RICHMOND", label: "Richmond, VA" },
  { value: "ROCHESTER", label: "Rochester‑Batavia‑Seneca Falls, NY" },
  { value: "SACRAMENTO", label: "Sacramento‑Roseville, CA‑NV" },
  { value: "SAN_ANTONIO", label: "San Antonio‑New Braunfels‑Pearsall, TX" },
  { value: "SAN_DIEGO", label: "San Diego‑Chula Vista‑Carlsbad, CA" },
  { value: "SF", label: "San Jose‑San Francisco‑Oakland, CA" },
  { value: "SEATTLE", label: "Seattle‑Tacoma, WA" },
  { value: "SPOKANE", label: "Spokane‑Spokane Valley‑Coeur d'Alene, WA‑ID" },
  { value: "ST_LOUIS", label: "St. Louis‑St. Charles‑Farmington, MO‑IL" },
  { value: "TUCSON", label: "Tucson‑Nogales, AZ" },
  { value: "VIRGINIA_BEACH", label: "Virginia Beach‑Norfolk, VA‑NC" },
  { value: "RUS", label: "Rest of United States" },
  { value: "ALASKA", label: "State of Alaska" },
  { value: "HAWAII", label: "State of Hawaii" }
];


function LocalitySelector({ id, value, onChange }) {
  return (
    <select
      id={id}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Locality Pay Area"
    >
      {localityOptions.map(option => (
        <option key={option.value} value={option.value}>
          {option.label} ({option.value})
        </option>
      ))}
      {/* Consider adding an "Other" or ensuring RUS covers all bases */}
    </select>
  );
}

export default LocalitySelector;
